import axios from './interceptor'
import { nodeApiUrl } from './config'

export default {
    async getTakeaway () {
        const res = await axios.get(`${nodeApiUrl}/c/system/takeaway`)
        return res.data
    },
    async getSDelivery () {
        const res = await axios.get(`${nodeApiUrl}/c/system/storedelivery`)
        return res.data
    },
}



// WEBPACK FOOTER //
// ./src/services/api/system.js